<template>
  <div>
    <br />
    <button
      type="button"
      class="btn btn-outline-primary btn-created"
      @click="showModal()"
    >Cadastrar usuário</button>
    <b-modal ref="my-modal" hide-footer title="Usuario">
      <div class="d-block">
        <form @submit="checkForm">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label for>Nome</label>
                <input type="text" class="form-control" v-model="payload.nomeUsuario" />
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label for>Email</label>
                <input type="email" class="form-control" v-model="payload.email" />
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label for>Login</label>
                <input type="text" class="form-control" v-model="payload.login" />
              </div>
            </div>

            <div class="col-md-12">
              <div class="form-group">
                <label for>Senha</label>
                <input type="password" class="form-control" v-model="payload.senha" />
              </div>
            </div>
          </div>
          <div class="text-right">
            <button type="submit" class="btn btn-outline-primary">Salvar</button>
          </div>
        </form>
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";

import { ParceiroService } from "@/http";

import { Usuario } from "@/soganhei";

export default {
  name: "Usuario",
  components: {},
  data: () => {
    return {
      payload: Usuario
    };
  },
  methods: {
    showModal: function() {
      this.payload = {};
      this.$refs["my-modal"].show();
    },
    visualizarUsuario(idUsuario) {
      ParceiroService.Usuario(idUsuario)
        .then(response => {
          this.payload = response.data;
          this.$refs["my-modal"].show();
        })
        .catch(error => {
          window.console.log(error);
        });
    },
    servicos(item) {
      this.payload.idServico = item.idServico;
    },
    checkForm(e) {
      e.preventDefault();

      const payload = Object.assign(Usuario, this.payload);

      payload.timezoneParceiro = moment().format();

      ParceiroService.CriarUsuario(payload)
        .then(response => {
          
          window.console.warn(response.statusText);
          this.$notify({
            group: "notify",
            text: "Salvo com sucessso",
            type: "success"
          });
          this.$refs["my-modal"].hide();

          this.$emit("usuarios");
        })
        .catch(error => {
            window.console.error(error.response)
        });
    }
  }
};
</script>